import 'sass/base.sass'
import React from 'react'
import FlashMessages from 'components/FlashMessages'
import ReloadWarning from 'components/ReloadWarning'
import ConfirmDialog from 'components/ConfirmDialog'
import ChangeEmailDialog from 'components/ChangeEmailDialog'
import { observer } from 'mobx-react'
import { HeaderRenderer } from 'components/Header'

@observer
export default class App extends React.Component {
  render () {
    const { rootStore } = this.props

    return (
      <div id="root">
        <HeaderRenderer rootStore={rootStore} />
        {this.props.children}
        <FlashMessages store={rootStore.flashMessageStore} position="bottomLeft" />
        <ReloadWarning authStore={rootStore.authStore} />
        <ChangeEmailDialog store={rootStore.changeEmailDialogStore} />
        <ConfirmDialog state={rootStore.billingStore.deletePaymentMethodDialog} danger yes="Delete Payment Method">
          Are you sure you want to delete this payment method?
        </ConfirmDialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/shell/App/index.jsx